import { LeadRequest } from 'types';

import { postToKong } from '../../../../../utils/fetchFromKong';

export const sendLeadRequest = (leaseCarId: string, request: LeadRequest): Promise<Response> => {
	const url = `privatelease/v1/leaseplan/leasecars/${leaseCarId}/lead`;

	return postToKong(url, request).then((response) => {
		if (!response.ok) {
			return Promise.reject(
				`Non OK response from leads backend: ${response.status} ${response.statusText}`
			);
		}
		return Promise.resolve(response);
	});
};
